<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div style="display: flex; align-items: center;justify-content: space-between;" class="py-2">
                    <h4 class="custom-font"> Establishment Detail {{schoolname}} </h4>
                </div>
            </div>
        </div>
        <div class="card row " *ngIf="establishmentDetailList != undefined && establishmentDetailList.length > 0">
            <div style="padding-left: 20px;padding-top: 10px;;">
                <h6 style="color: red;"> 1) File size should be less then 1 MB.</h6>
                <h6 style="color: red;"> 2) You can upload jpg, jpeg, png or pdf file only.</h6>
            </div>
            <div class=" col-lg-12 col-md-12 col-12 p-3">
                <div class="card col-mb-6">
                    <div class="card-header py-3">
                        <input type="text" class="form-control bg-white border-0 small" placeholder="Search for..."
                            [(ngModel)]="searchtext" aria-label="Search" aria-describedby="basic-addon2"
                            (keyup)="setpage()" />
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                        <thead>
                            <tr>
                                <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.</th>
                                <th class="pointer" scope="col" (click)="sortBy('Board')"> University </th>
                                <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                <th class="pointer" scope="col" (click)="sortBy('Section')">Faculty</th>
                                <th class="pointer" scope="col" (click)="sortBy('Course')">Course</th>
                                <th class="pointer" scope="col">Establishment Date</th>
                                <th class="pointer" scope="col">Document</th>
                                <th class="pointer" scope="col">Preview</th>
                                <th class="pointer" scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of establishmentDetailList | filter:searchtext ;let i = index">
                                <td>{{r.SrNo}}</td>
                                <td>
                                    <p>{{r.Board}}</p>
                                </td>
                                <td>
                                    <p>{{r.Medium}}</p>
                                </td>
                                <td>
                                    <p>{{r.Section}}</p>
                                </td>
                                <td>
                                    <p>{{r.Course}}</p>
                                </td>
                                <td>
                                    <!-- <div class="col-lg-4 col-md-8 col-4"> -->
                                    <input type="date" placeholder="Select Date" id="ExpenseDate{{i}}"
                                        (blur)="setdate(i)" class="form-control" name="ExpenseDate{{i}}">
                                    <!-- </div> -->
                                </td>
                                <td>
                                    <!-- <p><input id="input-b1" name="input-b1" type="file" class="file" data-browse-on-zone-click="true"
                                        (change)="uploadImage($event,i)" ></p> -->
                                    <!-- <div class="custom-file mb-3">
                                            <input type="file" class="custom-file-input" id="customFile"  (change)="uploadImage($event,i)" name="filename">
                                            <label class="custom-file-label" for="customFile">Choose file</label>
                                          </div> -->
                                    <!-- <div class="file-upload-wrapper"> -->
                                    <input type="file" id="input-file-max-fs" id="customFile" name="customFile"
                                        (change)="uploadImage($event,i)" class="file-upload" data-max-file-size="2M" />
                                    <!-- </div> -->
                                </td>
                                <td>
                                    <p>
                                        <a href="{{r.ViewURL}}" target="_blank">
                                            <img src="{{r.ViewURL}}" class="img-fluid no-img "
                                                style="width: 110px;height: 110px;" id="preview_{{i}}" />
                                        </a>
                                    </p>
                                </td>
                                <td>
                                    &nbsp; <button type="button" class="btn btn-danger" *ngIf="r.HashCode != ''"
                                        (click)="deleteEstablishmentDetail(r.HashCode,r.Document)">Delete</button>
                                    <!-- </div> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button class="btn btn-success" type="submit" style="margin: 5px;" (click)="saveDetail()">Save</button>
                <button type="button" class="btn btn-danger" (click)="Cancel()">Cancel</button>
                <!-- <div class="card-footer pb-3 pt-3 mb-4" align="center">
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                </div> -->
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>